var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalksWizardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5795 7.6632C12.5795 10.189 10.1453 11.957 7.50033 11.957C4.85533 11.957 2.42116 10.189 2.42116 7.6632H0.791992C0.791992 10.5342 3.39866 12.9084 6.54199 13.3209V16.0824H8.45866V13.3209C11.602 12.9084 14.2087 10.5342 14.2087 7.6632H12.5795ZM6.35033 2.52746C6.35033 1.97179 6.86783 1.51715 7.50033 1.51715C8.13283 1.51715 8.65033 1.97179 8.65033 2.52746L8.64074 7.74739C8.64074 8.30306 8.13283 8.7577 7.50033 8.7577C6.86783 8.7577 6.35033 8.30306 6.35033 7.74739V2.52746ZM7.50033 10.189C8.26282 10.189 8.99409 9.92286 9.53326 9.44919C10.0724 8.97552 10.3753 8.33307 10.3753 7.6632V2.61165C10.3753 1.94177 10.0724 1.29933 9.53326 0.825659C8.99409 0.351984 8.26282 0.0858765 7.50033 0.0858765C6.73783 0.0858765 6.00656 0.351984 5.46739 0.825659C4.92823 1.29933 4.62533 1.94177 4.62533 2.61165V7.6632C4.62533 8.33307 4.92823 8.97552 5.46739 9.44919C6.00656 9.92286 6.73783 10.189 7.50033 10.189Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalksWizardIcon);
export default __webpack_public_path__ + "static/media/talks-wizard-icon.d09d2fa6.svg";
export { ForwardRef as ReactComponent };